export const AVAILABLE_COUNTRIES_AND_DETAILS = {
  US: { administrativeDivision: 'State', postalTerm: 'Zip' },
  CA: { administrativeDivision: 'Province', postalTerm: 'Postal Code' },
};

export const AVAILABLE_COUNTRY_CODES = ['US', 'CA'];
export const DEFAULT_COUNTRY = 'US';
